import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "filename"]
  static values = { maxSize: { type: Number, default: 10 } }

  connect() {
    this.imgExtensionsRegex = /(.*?)\.(jpg|jpeg|gif|png|webp|pdf)$/iu
  }

  displayFilename() {
    const input = this.inputTarget
    const filename = this.filenameTarget
    let message = 'ファイルが選択されていません'
    let hasError = false
    const errorColorClass = 'error-color'

    if (input && input.files && input.files[0]) {
      const file = input.files[0]
      message = file.name
      const uploadedFileSizeMB = file.size / (1024 * 1024)

      if (!this.imgExtensionsRegex.test(file.name)) {
        message = '正しいファイルを選択してください'
        hasError = true
      } else if (uploadedFileSizeMB > this.maxSizeValue) {
        const fieldName = input.getAttribute('data-field-name') || ''
        message = `${fieldName}は${this.maxSizeValue}MB以下にしてください`
        hasError = true
      }

      if (hasError) {
        input.value = ''
        filename.classList.add(errorColorClass)
      } else {
        filename.classList.remove(errorColorClass)
      }
    }

    filename.textContent = message
  }
}
